import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import { Tabs } from "@cars24/turbo-web/lib/tabs";
import PropTypes from "prop-types";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { NUMBER } from "../../../constants/app-constants";
import rightArrowIcon from "../../../images/arrow-right.svg";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const LoanDetails = ({
    content,
    images,
    imageSlug,
    selectedInnerIndex,
    onSelectInnerIndex
}) => {
    const { tokens } = useTokens();
    const { tabList = [] } = content || {};
    const [selectedIndex, setSelectedIndex] = useState(selectedInnerIndex);
    const [panelContent, setPanelContent] = useState({});

    const handleTabChange = (val) => {
        const newSelectedIndex = tabList.findIndex(({ id }) => id === val.id);
        setSelectedIndex(newSelectedIndex);
        setPanelContent(tabList?.[newSelectedIndex]?.content || {});
        onSelectInnerIndex(newSelectedIndex);
    };

    useEffect(() => {
        setPanelContent(tabList?.[selectedIndex]?.content || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);

    useEffect(() => {
        setSelectedIndex(selectedInnerIndex);
    }, [selectedInnerIndex]);

    let type = "";

    if (Array.isArray(panelContent)) {
        type = panelContent[0]?.type;
    } else {
        type = panelContent?.type;
    }

    const image = images?.filter((img) => img?.imageSlug === imageSlug)?.[0];

    const renderPanelContent = () => {
        switch (type) {
        case "list":
            return (
                <div styleName={"styles.listParentContainer"}>
                    {panelContent[0]?.items?.map((item, index) => (
                        <div styleName={"styles.listTypeItem"} key={index}>
                            <img
                                src={rightArrowIcon}
                                alt="list item"
                                loading="lazy"
                                width={20}
                                height={20}
                            />
                            <div styleName={"styles.textGap"}>
                                <Label
                                    level={NUMBER.THREE}
                                    fontWeight="medium"
                                    color={tokens.text_default_text_primary}
                                >
                                    {item?.title}
                                </Label>
                                {item?.description && Array.isArray(item?.description) ? (
                                    <ul>
                                        {item?.description?.map((desc, descIndex) => (
                                            <li key={descIndex}>
                                                <BodyText
                                                    level={NUMBER.TWO}
                                                    color={tokens.text_default_text_secondary}
                                                >
                                                    {desc}
                                                </BodyText>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <BodyText
                                        level={NUMBER.TWO}
                                        color={tokens.text_default_text_secondary}
                                    >
                                        {item?.description}
                                    </BodyText>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        case "text":
            return (
                <div styleName={"styles.textTypeContainer"}>
                    <BodyText level={NUMBER.TWO}>
                        {panelContent[0]?.value}{" "}
                        {panelContent[0]?.emphasis && (
                            <div styleName={"styles.emphasis"}>
                                <BodyText level={NUMBER.TWO}>
                                    {panelContent[0]?.emphasis}
                                </BodyText>
                            </div>
                        )}
                    </BodyText>
                </div>
            );
        default:
            return (
                <div styleName={"styles.descriptionContainer"}>
                    <div styleName={"styles.textContainer"}>
                        <Label
                            level={NUMBER.TWO}
                            fontWeight="600"
                            color={tokens.text_default_text_primary}
                        >
                            {panelContent?.title || ""}
                        </Label>
                        <div styleName={"styles.listContainer"}>
                            {panelContent?.description &&
                  (Array.isArray(panelContent?.description) ? (
                    panelContent?.description?.map((item, index) => (
                        <div key={index} styleName={"styles.listItem"}>
                            <img
                                src={rightArrowIcon}
                                alt="list item"
                                loading="lazy"
                                width={20}
                                height={20}
                            />
                            <BodyText level={NUMBER.TWO}>{item}</BodyText>
                        </div>
                    ))
                  ) : (
                      <BodyText level={NUMBER.TWO}>
                          {panelContent?.description}
                      </BodyText>
                  ))}
                        </div>
                    </div>
                    <img
                        src={image?.desktopImage}
                        alt="overview"
                        styleName={"styles.mainImg"}
                        loading="lazy"
                        width={220}
                        height={326}
                    />
                </div>
            );
        }
    };

    return (
        <>
            <div styleName={"styles.detailsTabContainer"}>
                <Tabs
                    variant="line"
                    orientation="vertical"
                    items={tabList.map(({ id, title }) => ({
                        id,
                        title,
                        disabled: false
                    }))}
                    onClick={handleTabChange}
                    defaultSelectedIndex={selectedIndex}
                />
            </div>
            <div styleName={"styles.detailsTabPanel"}>{renderPanelContent()}</div>
        </>
    );
};

LoanDetails.propTypes = {
    content: PropTypes.object,
    images: PropTypes.array,
    imageSlug: PropTypes.string,
    selectedInnerIndex: PropTypes.number,
    onSelectInnerIndex: PropTypes.func
};

export default LoanDetails;
